export default {
  data() {
    return {
      text: '',
    };
  },
  methods: {
    aplicarFiltro() {
      this.$aplicaFiltroEmURL(this.filtro.filtro, this.text, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.text
      });
    },
    excluirFiltro() {
      this.$emit('excluirFiltro', this.filtro.filtro, this.path);
    },
  },
  watch: {
    '$store.state.filtroAplicados': {
      handler(newFiltrosAplicados) {
        const filtroAplicado = newFiltrosAplicados[this.filtro.filtro];
        if (this.filtro.default && !filtroAplicado) {
          this.text = '';
          this.valor = '';
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    const filtros = this.$store.state.filtroAplicados;
    if (filtros.hasOwnProperty(this.filtro.filtro)) {
      this.text = filtros[this.filtro.filtro];
      this.valor = this.filtro.filtro + '=' + this.text;
    }
  }
};
